export default "__VITE_ASSET__DphEQD7Z__"